import template from './AxSurveyFieldDisconnectCall.html';

function AxSurveyFieldDisconnectCall() {

  return {
    restrict: 'E',
    scope: {
      // We don't want long names :)
      axC: '=axControl', // Bi-directional binding - to można zapodawac do kązdej dyrektywy - definiuje jak są ich wartości bindowane
      li18n: '=axI18n'
    },
    link: link,
    template,
    controllerAs: 'vm',
    bindToController: true,
    controller: ['Helpers', controller]
  }
}

function controller(helpers) {

  var vm = this;
  helpers.initField(vm);

  vm.canDisconnectCall = function () {
    return helpers.canDisconnectCall();
  };
  vm.disconnectCall = function () {
    helpers.disconnectCall();
  };
  helpers.endInitField(vm);
}

function link($scope, $element, $attrs, $ctrl) {
  var input = $element.find("input[type=button]");
}

export { AxSurveyFieldDisconnectCall };
